module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "background-light"
  }, [_c('img', {
    staticClass: "footer-logo",
    attrs: {
      "src": "/static/img/icgc-logo.png",
      "alt": "Institut Cartogràfic i Geològic de Catalunya"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "logo-centered",
    attrs: {
      "href": "//www.instamaps.cat",
      "target": _vm.isInIframe ? '_blank' : '_parent'
    }
  }, [_c('img', {
    staticClass: "instamaps-logo",
    attrs: {
      "src": "/static/img/instamaps-v2-logo-flat.png",
      "alt": "Logo Instamaps",
      "title": _vm.$t('menu.home')
    }
  })]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "cookies-footer"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "clear-fix"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4bf7d36b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/shared/components/footer/footer.vue
// module id = 131
// module chunks = 0